import React from 'react'
import "./Loader.scss"
const Loader = () => {
  return (
    <>
      <div className="loader_parent parent">
        <div className="loader"></div>
      </div>
    </>
  )
}

export default Loader
